import chevronDownIcon from "@public/img/chevron-down.svg";
import React, { useEffect, useRef, useState } from "react";
import "@/styles/select-field.css";

type SelectFieldProps = {
    uniqueKey: string;
    options: { label: string; value: string }[];
    onChange: (value: string) => void;
    value: string;
    disabled?: boolean;
    rootClassName?: string;
};

export default function SelectField({ uniqueKey, options, onChange, value, disabled, rootClassName }: SelectFieldProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(function () {
        setCurrentValue(value);
    }, [value]);

    useEffect(function () {
        function onWindowClick(e: MouseEvent) {
            var target = e.target || e.srcElement;
            if (!target || !containerRef.current) {
                return;
            }
            if (!containerRef.current.contains(target as Node)) {
                setIsOpen(false);
            }
        }

        window.addEventListener("click", onWindowClick);
        return function () {
            window.removeEventListener("click", onWindowClick);
        };
    }, []);

    var currentOption = options.find(function (option) {
        return option.value === currentValue;
    });
    var currentLabel = currentOption ? currentOption.label : "";

    function handleToggle(e: React.MouseEvent) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setIsOpen(!isOpen);
    }

    function handleChange(nextValue: string) {
        if (disabled) {
            return;
        }
        setCurrentValue(nextValue);
        onChange(nextValue);
        setIsOpen(false);
    }

    var rootClass = "select-field select-field-" + uniqueKey;
    if (disabled) {
        rootClass += " select-field--disabled";
    }
    if (rootClassName) {
        rootClass += " " + rootClassName;
    }

    var chevronClass = "select-field__chevron";
    if (isOpen) {
        chevronClass += " select-field__chevron--open";
    }

    var menuClass = "select-field__menu select-scrollbar";
    if (isOpen) {
        menuClass += " select-field__menu--open";
    }

    return (
        <div ref={containerRef} className={rootClass}>
            <button
                type="button"
                className="select-field__trigger"
                onClick={handleToggle}
                disabled={disabled}
            >
                <span className="select-field__label">{currentLabel}</span>
                <img src={chevronDownIcon} alt="" className={chevronClass} />
            </button>

            <div className={menuClass}>
                {options.map(function (option) {
                    var optionClass = "select-field__option";
                    if (currentValue === option.value) {
                        optionClass += " select-field__option--active";
                    }
                    return (
                        <button
                            key={option.value || option.label}
                            type="button"
                            className={optionClass}
                            onClick={function (e) {
                                e.stopPropagation();
                                handleChange(option.value);
                            }}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
